import axios from "axios";
import {
  NotificationBatch,
  NotificationItem,
  NotifListByBatchIdParams,
  NotifListByBatchIdResponse,
  NotifListParams,
  NotifListResponse,
  TriggerNotifPayload,
  UploadBatchFileParams,
  UploadBatchJsonParams,
  UploadResponse,
} from "../interfaces/notifications-interface";
import notifAxiosInstance from "../utils/notif-axios-instance";

export const getBatchNotifList = async (
  params: NotifListParams
): Promise<NotifListResponse> => {
  try {
    const {
      cursor = 0,
      limit = 20,
      sortField = "createdOn",
      sortOrder = "desc",
      status,
    } = params;

    const response = await notifAxiosInstance.get("/notifications/batch", {
      params: {
        cursor,
        limit,
        sortField,
        sortOrder,
        status,
      },
    });

    return response.data;
  } catch (error: any) {
    console.error("Failed to list batch notifications:", error);
    throw error?.response?.data || error;
  }
};

export const getNotifListByBatch = async (
  params: NotifListByBatchIdParams
): Promise<NotifListByBatchIdResponse> => {
  try {
    const {
      cursor = 0,
      limit = 20,
      sortField = "createdOn",
      sortOrder = "desc",
      status,
      batchId,
    } = params;

    const response = await notifAxiosInstance.get("/notifications", {
      params: {
        cursor,
        limit,
        sortField,
        sortOrder,
        status,
        batchId,
      },
    });

    return response.data;
  } catch (error: any) {
    console.error("Failed to list notifications for batch:", error);
    throw error?.response?.data || error;
  }
};

export const getBatchNotif = async (
  batchId: string
): Promise<NotificationBatch> => {
  try {
    const response = await notifAxiosInstance.get(
      `/notifications/batch/${batchId}`
    );

    return response.data.batch;
  } catch (error: any) {
    console.error("Failed to get batch notif:", error);
    throw error?.response?.data || error;
  }
};

export const triggerNotif = async (
  payload: TriggerNotifPayload
): Promise<NotificationItem> => {
  try {
    const payloadCopy = {
      topic:
        payload.topic &&
        (payload.topic.trim() === "" ||
          payload.topic === null ||
          payload.topic === undefined)
          ? undefined
          : payload.topic,
      recipientId:
        payload.recipientId &&
        (payload.recipientId.trim() === "" ||
          payload.recipientId === null ||
          payload.recipientId === undefined)
          ? undefined
          : payload.recipientId,
      batchId: payload.batchId,
      title: payload.title,
      preview: payload.preview,
      body: payload.body,
      imageUrl: payload.imageUrl,
      clickAction: payload.clickAction,
      ttl: payload.ttl,
      messageType: payload.messageType,
      mobileAppDisplay: payload.mobileAppDisplay,
      priority: payload.priority,
    };
    console.log("test", payloadCopy);

    const response = await notifAxiosInstance.post(
      "/notifications",
      payloadCopy
    );

    return response.data;
  } catch (error: any) {
    console.error("Upload single notif failed:", error);
    throw error?.response?.data || error;
  }
};

export async function uploadNotificationBatch(
  input: UploadBatchJsonParams | UploadBatchFileParams
) {
  try {
    if ("file" in input) {
      const formData = new FormData();
      formData.append("file", input.file);

      const token = localStorage.getItem("notifIdToken");

      const response = await axios.post<UploadResponse>(
        `${process.env.REACT_APP_NOTIFICATION_MANAGEMENT_URL}/notifications/batch`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          maxBodyLength: Infinity,
          maxContentLength: Infinity,
        }
      );

      return response?.data;
    } else {
      const response = await notifAxiosInstance.post<UploadResponse>(
        "/notifications/batch",
        input
      );

      return response.data;
    }
  } catch (error: any) {
    console.error("Upload failed:", error);
    throw error?.response?.data || error;
  }
}

export const deleteBatchNotif = async (
  batchId: string
): Promise<NotificationBatch> => {
  try {
    const response = await notifAxiosInstance.delete(
      `/notifications/batch/${batchId}`
    );

    return response.data.message;
  } catch (error: any) {
    console.error("Failed to delete batch notif:", error);
    throw error?.response?.data || error;
  }
};

interface TriggerResponse {
  message: string;
  response: {
    batchId: string;
    sentToSqs: number;
  };
}

export const triggerBatchUpload = async (
  batchId: string
): Promise<TriggerResponse> => {
  try {
    const response = await axios.post<TriggerResponse>(
      `${process.env.REACT_APP_NOTIFICATION_MANAGEMENT_URL}/worker/notifications/batch`,
      { batchId },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error: any) {
    console.error("Trigger failed:", error);
    throw error?.response?.data || error;
  }
};
